import React, { useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function studentPhotoSrc(studentId, photoPath) {
  if (!studentId || !photoPath) return null;
  const token = localStorage.getItem("token") || "";
  return `${BACKEND}/api/students/${studentId}/photo?auth=${encodeURIComponent(token)}&v=${encodeURIComponent(photoPath.slice(-12))}`;
}

const initialsOf = (name) => (name || "?").split(" ").filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase();

export default function StudentAvatar({ studentId, photoPath, name, className = "w-9 h-9 rounded-full text-xs", testId }) {
  const [failed, setFailed] = useState(false);
  const src = !failed && studentPhotoSrc(studentId, photoPath);
  return (
    <div className={`overflow-hidden bg-[#1C352D] text-white font-semibold grid place-items-center shrink-0 ${className}`} data-testid={testId}>
      {src ? <img src={src} alt={name || ""} loading="lazy" className="w-full h-full object-cover" onError={() => setFailed(true)}/> : initialsOf(name)}
    </div>
  );
}
